import React from "react";
import "./PrivacyPolicy.css";
import Footer from "../../components/layout/footer";
import Header from "../../components/layout/header";
import FlashSale from "../Flash Sale/FlashSale";

const PrivacyPolicy = () => {
  return (
    <>
      <Header />
      <div className="privacy-policy">
        <h1>Privacy Policy</h1>
        <div className="privacy-policy-content">
          <p>
            This Privacy Policy sets out how Kharutaai LLP, uses &amp; protects any information that
            you give us when you use this website.
            <br />
            ‘Kharutaai LLP’, is committed to ensuring that your Privacy is protected.
            Kharutaai LLP, may change this policy from time to time by updating this page.
            <br />
            You should check this page from time to time to ensure that you are happy with any
            changes.
          </p>
          <h2>1. Information We Collect</h2>
          <p>
            We may collect the following-
            <ul>
              <li>Name & Date of Birth.</li>
              <li>Contact Information including Email Address.</li>
              <li>Demographic information such as postcode, preferences & interests.</li>
              <li>Other Information relevant to customer surveys &/or offers.</li>
            </ul>
          </p>
          <h2>2. How We Use Your Information</h2>
          <p>
            <ul>
              <li>Internal record keeping.</li>
              <li>We may use the information to improve our Products & Services.</li>
              <li>We may periodically send Promotional Messages about New Products, Special Offers, or other Information which we think you may find interesting using the Email Address/Number which you have provided.</li>
              <li>From time to time, we may also use your information to contact you for Market Research Purposes. We may contact you by Email/WhatsApp.</li>
              <li>We may use the information to customize the Website according to your interests.</li>
              <li>For enhancing security.</li>
            </ul>
          </p>
          <h2>3. Cookies and Similar Technologies</h2>
          <p>
            We implement appropriate Security Measures to protect your personal information from
            unauthorized access, disclosure, or destruction. However, please be aware that no
            method of transmission over the internet or electronic storage is completely secure.
            <br />
            <br />
            We use traffic log cookies to identify which pages are being used. This helps us analyze
            data about webpage traffic &amp; improve our website in order to tailor it to customer needs.
            <br />
            <br />
            We only use this information for statistical analysis purposes &amp; then the data is removed
            from the system.
            <br />
            Overall, cookies help us provide you with a better website by enabling us to monitor
            which pages you find useful &amp; which you do not. A cookie in no way gives us access to
            your computer or any information about you, other than the data you choose to share
            with us.
            <br />
            <br />
            You can choose to accept or decline cookies. Most web browsers automatically accept
            cookies, but you can usually modify your browser setting to decline cookies if you
            prefer. This may prevent you from taking full advantage of the website.
          </p>
          <p>
            We use traffic log cookies to identify which pages are being used.
            This helps us analyze data about webpage traffic & improve our
            website in order to tailor it to customer needs. We only use this
            information for statistical analysis purposes & then the data is
            removed from the system.
          </p>
          <p>
            Overall, cookies help us provide you with a better website by
            enabling us to monitor which pages you find useful & which you do
            not. A cookie in no way gives us access to your computer or any
            information about you, other than the data you choose to share with
            us.
          </p>
          <p>
            You can choose to accept or decline cookies. Most web browsers
            automatically accept cookies, but you can usually modify your
            browser setting to decline cookies if you prefer. This may prevent
            you from taking full advantage of the website.
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;
